import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { MantineProvider, Container } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import CubbyContainer from "./CubbyContainer";
import RizvoiceContainer from "./RizvoiceContainer";
import DocsContainer from "./docs/DocsContainer";
import DocsIndexContainer from "./docs/DocsIndexContainer";
import BobsWorkspaceContainer from "./bobs/components/BobsWorkspaceContainer";
import DecodeInvoiceContainer from "./decodeInvoice/components/DecodeInvoiceContainer";
import SatoshiConverterContainer from "./satoshiConverter/components/SatoshiConverterContainer";
import CheckBitcoinAddressContainer from "./checkBitcoinAddress/components/CheckBitcoinAddressContainer";
import LightningAddressContainer from "./lightningAddress/components/LightningAddressContainer";
import TxStatusContainer from "./txStatus/components/TxStatusContainer";
import BitcoinFeesContainer from "./bitcoinFees/components/BitcoinFeesContainer";
import BtcToSatsContainer from "./btcSatsConverter/BtcToSatsContainer";
import SatsToBtcContainer from "./btcSatsConverter/SatsToBtcContainer";
import { isConverterPath } from "./satoshiConverter/helpers/currencies";

const AppContainer: React.FC = observer(() => {
  const path = window.location.pathname;
  const isConverterPage = isConverterPath(path);

  return (
    <MantineProvider
      defaultColorScheme="dark"
      theme={{ fontFamily: "courier-prime, monospace" }}
    >
      <Notifications position="top-center" />

      {path === "/w" ? (
        // lightning wallet gets the whole viewport (no Mantine <Container>)
        <BobsWorkspaceContainer />
      ) : path === "/decode_invoice" ? (
        // decode invoice tool gets the whole viewport
        <DecodeInvoiceContainer />
      ) : path === "/check_bitcoin_address" ? (
        // bitcoin address checker gets the whole viewport
        <CheckBitcoinAddressContainer />
      ) : path === "/lightning-address" ? (
        // lightning address tester gets the whole viewport
        <LightningAddressContainer />
      ) : path === "/unconfirmed-bitcoin-transaction" ? (
        // stuck / unconfirmed transaction checker gets the whole viewport
        <TxStatusContainer />
      ) : path === "/bitcoin-fees" ? (
        // live on-chain fee page gets the whole viewport
        <BitcoinFeesContainer />
      ) : path === "/btc-to-sats-converter" ? (
        <BtcToSatsContainer />
      ) : path === "/sats-to-btc-converter" ? (
        <SatsToBtcContainer />
      ) : isConverterPage ? (
        // satoshi converter gets the whole viewport
        <SatoshiConverterContainer />
      ) : (
        // everything else keeps the centered max-width container
        <Container size="md">
          {path === "/node" && <CubbyContainer />}
          {path === "/rizvoice" && <RizvoiceContainer />}
          {path === "/docs" && <DocsIndexContainer />}
          {path.startsWith("/docs/") && <DocsContainer />}
        </Container>
      )}
    </MantineProvider>
  );
});

export default AppContainer;
